import { useCallback, useEffect, useRef, useState } from 'react';
import { useLanguage } from '../context/LanguageContext';

const COMPANY_LOGOS = [
  'img_d37078085212.webp', 'img_64dad43cc6a2.webp', 'img_3429590844e2.webp', 'img_aaf3363a0456.webp',
  'img_9365e97198a2.webp', 'img_8fbabc2ce2e4.webp', 'img_13410c036f05.webp', 'img_a790bb04048e.webp',
  'img_ebcfca53b93d.webp', 'img_3d6469d3b4da.webp', 'img_b1775e7d6fde.webp', 'img_24e691e5a186.webp',
];

export default function Splash() {
  const { isEN } = useLanguage();
  const [isDone, setIsDone] = useState(false);
  const [hidden, setHidden] = useState(false);
  const dismissedRef = useRef(false);
  const timersRef = useRef([]);

  const dismiss = useCallback(() => {
    if (dismissedRef.current) return;
    dismissedRef.current = true;
    setIsDone(true);
    document.body.classList.remove('splash-active');
    timersRef.current.push(setTimeout(() => setHidden(true), 900));
  }, []);

  useEffect(() => {
    const timers = timersRef.current;
    document.body.classList.add('splash-active');
    timers.push(setTimeout(dismiss, 3800));
    return () => {
      timers.forEach(clearTimeout);
      document.body.classList.remove('splash-active');
    };
  }, [dismiss]);

  if (hidden) return null;

  return (
    <div id="splash" className={'splash' + (isDone ? ' is-done' : '')} role="status" aria-label={isEN ? 'Elhaware Group' : 'مجموعة الهواري'}>
      <div className="splash__bg"></div>
      <div className="splash__inner">
        <div className="splash__emblem">
          <svg className="splash__ring" viewBox="0 0 120 120" aria-hidden="true">
            <circle cx="60" cy="60" r="56"></circle>
          </svg>
          <span className="splash__disc"></span>
          <img className="splash__logo" src="/assets/logo-c.png" alt={isEN ? 'Elhaware Group' : 'مجموعة الهواري'} />
        </div>
        <div className="splash__word">{isEN ? 'Elhaware Group' : 'مجموعة الهواري'}</div>
        <div className="splash__tag"><span className="splash__rule"></span>EST. 2015<span className="splash__rule"></span></div>
        <div className="splash__logos">
          {COMPANY_LOGOS.map((name) => (
            <span className="splash__co" key={name}>
              <img src={`/assets/img/${name}`} alt="" loading="lazy" />
            </span>
          ))}
        </div>
      </div>
      <button className="splash__skip" type="button" onClick={dismiss}>
        {isEN ? 'Skip' : 'تخطّي'} <span className="arr">←</span>
      </button>
    </div>
  );
}
